// extracted by mini-css-extract-plugin
export default {"block":"MockLoadingBlock_block__3095+","gradient":"MockLoadingBlock_gradient__B0EC+","no_bevel":"MockLoadingBlock_no_bevel__AyV2d","no_margin":"MockLoadingBlock_no_margin__1UblF"};